Vue.component('custom-select', () => import('./custom-select.vue'))
Vue.component('my-materials', () => import('./my-materials.vue'))

export default new Vue({
    el: '#my-learning',
    data: {
        isTracks: false,
        trainings: [],
        paginate: {},
        isMobile: $(window).width() <= 767 ? true : false,
        loading: false,
        options: ['Todos os treinamentos', 'Concluídos', 'Em andamento', 'Não iniciados', 'Reprovados'],
        initialOption: "Todos os treinamentos",
        materials: null,
        material_name: null,
        input:{
            name: '',
            status: 0,
        },
        certificate: {
            background: '',
            id: '',
        },
    },
    created: function () {
        const queryParams = new URLSearchParams(window.location.search);
        const tab = queryParams.get('tab');

        if (tab === 'tracks') {
            this.isTracks = true;
            this.options = ['Todas as trilhas', 'Concluídas', 'Em andamento'];
            this.initialOption = "Todas as trilhas";
        }

        this.getTrainings();
    },
    updated: function () {},
    methods: {
        switchTab(mode) {
            this.isTracks = (mode === 'tracks');

            if (this.isTracks) {
                this.options = ['Todas as trilhas', 'Concluídas', 'Em andamento'];
                this.initialOption = "Todas as trilhas";
            } else {
                this.options = ['Todos os treinamentos', 'Concluídos', 'Em andamento', 'Não iniciados', 'Reprovados'];
                this.initialOption = "Todos os treinamentos";
            }

            this.input.name = '';
            this.input.status = 0;
            this.getTrainings(1);
        },
        setTrainings(value){
            this.trainings = value;
        },
        setPaginate(value){
            this.paginate = value;
        },
        async getTrainings(page = 1) {
            var self = this;

            if (self.loading) return;

            let endpoint = self.isTracks ? 'training/track' : 'training';

            let searchKey = self.isTracks ? 'content' : 'name';
            let searchString = self.input.name ? `&${searchKey}=${self.input.name}` : '';

            let filterParams = '';
            if (self.isTracks) {
                if (self.input.status === 1) {
                    filterParams = '&completed=1';
                } else if (self.input.status === 2) {
                    filterParams = '&completed=0';
                }
            } else {
                filterParams = self.input.status ? `&status=${self.input.status}` : '';
            }

            self.loading = true;
            let response = await axios.get(
                `${api_url}${endpoint}?mycourse=true&active=1&per_page=8&page=${page}${searchString}${filterParams}`,
                {headers: $headerAuth}
            );

            let trainings = response.data.data;
            let column = 0;
            trainings.forEach(training => {
                if (self.isTracks) {
                    training.url = '/trilhas/' + training.slug;
                } else {
                    let c = (training.category) ? training.category.slug : '';
                    training.url = '/treinamentos/' + (c ? c + '/' : '') + training.slug;
                }
                training.content = training.content ? training.content.cutWord() : '';
                training.certificate = (training.subscriber) ? training.subscriber.certificate : null;

                column = (column > 3) ? 0 : column;
                training.column = column;
                column++;

                training.materials = (training.materials && training.materials.length > 0) ? training.materials : false;

                if (training.subscriber) {
                    training.subscriber.evaluation = (training.subscriber.evaluation && training.subscriber.evaluation.length > 0) ? training.subscriber.evaluation : false;
                }
            });

            self.trainings = trainings;

            self.paginate = response.data;

            setTimeout(function () {
                self.loading = false
            }, 500);
        },
        getTrainingsByPage(page) {
            this.getTrainings(page);
            $([document.documentElement, document.body]).animate({
                scrollTop: $("#my-learning").offset().top - 100
            }, 0);
        },
        showCertificate(training){
            this.certificate.background = training.certificate;
            this.certificate.id = training.id;
        },
        showMaterial(training){
            this.materials = training.materials;
            this.material_name = training.name;
        },
        async downloadCertified(id) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "image/png");
            myHeaders.append("Authorization", $headerAuth['Authorization']);

            var url = `${api_url}training/${id}/certified/download`;

            var myInit = { method: 'GET',
               headers: myHeaders,
               mode: 'cors',
               cache: 'default' };

            var myRequest = new Request(url, myInit);

            fetch(url, myRequest)
            .then(response => response.blob())
            .then(blob => {
                let blobUrl = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.download = url.replace(/^.*[\\\/]/, '');
                a.href = blobUrl;
                document.body.appendChild(a);
                a.click();
                a.remove();
            });
        },
        async downloadMaterial(id) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "image/png");
            myHeaders.append("Authorization", $headerAuth['Authorization']);

            var url = `${api_url}training/material/download/${id}`;

            var myInit = { method: 'GET',
               headers: myHeaders,
               mode: 'cors',
               cache: 'default' };

            var myRequest = new Request(url, myInit);

            fetch(url, myRequest)
            .then(response => response.blob())
            .then(blob => {
                let blobUrl = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.download = url.replace(/^.*[\\\/]/, '');
                a.href = blobUrl;
                document.body.appendChild(a);
                a.click();
                a.remove();
            });
        }
    }
});
